import { DocumentChecklist } from "../../document-checklist/DocumentChecklist"

export const DocumentChecklistAttribute = ({
    attributeId,
    checklistId,
    entity,
    entityId,
    relativePath,
    readOnly,
    className,
}: {
    attributeId: string,
    entity?: string,
    entityId?: string,
    checklistId?: string,
    relativePath?: string,
    readOnly?: boolean,
    className?: string,
}) => {
    if (!checklistId) return <></>
    
    return <>
        <DocumentChecklist
            className={className}
            readonly={readOnly}
            entityId={entityId}
            entity={entity}
            fieldId={attributeId}
            relativePath={relativePath}
            checklistId={checklistId} />
    </>
}
